import { render, staticRenderFns } from "./DomainesList.vue?vue&type=template&id=55737821&scoped=true&"
import script from "./DomainesList.vue?vue&type=script&lang=js&"
export * from "./DomainesList.vue?vue&type=script&lang=js&"
import style0 from "./DomainesList.vue?vue&type=style&index=0&id=55737821&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "55737821",
  null
  
)

export default component.exports